// extracted by mini-css-extract-plugin
module.exports = {"toggle":"filter-toggle_toggle__2sbO8","collapsed":"filter-toggle_collapsed__3yeZE"};